import React, { Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import marketingI18n from '../../marketing/i18n';
import MarketingRouter from '../../marketing/MarketingRouter';
import MarketingErrorBoundary from '../../marketing/MarketingErrorBoundary';
import MarketingHeader from '../../marketing/Unit/Header';

import '../../marketing/index.module.css';
import '../../marketing/base.module.css';
import '../../marketing/App.module.css';
import '../../marketing/report.module.css';

function MarketingContainer() {
  return (
    <I18nextProvider i18n={marketingI18n}>
      <MarketingErrorBoundary>
        <Suspense fallback={<div style={{ padding: 24, background: '#fff' }}>Loading marketing...</div>}>
          <div className="marketing-module" style={{ minHeight: '100vh', background: '#fff' }}>
            <MarketingHeader />
            <MarketingRouter />
          </div>
        </Suspense>
      </MarketingErrorBoundary>
    </I18nextProvider>
  );
}

export default MarketingContainer;
